import React from 'react'
import { Widget } from 'widgets-for-react'
import { any, async, fromJSX, Updater } from 'widgets-for-react'
import { subcentraBreadcrumbs } from '../../../../utils/breadcrumbs'
import { slugify } from '../../../../utils/utils'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, Link, Page, SubcentraPage } from '../../cmsPageState'
import { SubcentraPageHeader } from './subcentraPageLayout'

export const subcentraPageWidget =
  (acceptVideoCookie: () => void) =>
  (page: SubcentraPage): Widget<Updater<Page>> =>
    any([
      async<boolean>(page.hasWaitingTimesState).map(cmsPageStateUpdaters.hasWaitingTimesPageStateUpdater),
      async<Link[]>(page.childrenState).map(cmsPageStateUpdaters.pageTreeStateUpdater),
      // async(page.hasWaitingTimesState).map(cmsPageStateUpdaters.hasWaitingTimesPageStateUpdater),
      fromJSX((setState) => (
        <SubcentraPageHeader
        waitingTimesUrl={
            page.subCentra?.centrum &&
            page.hasWaitingTimesState.kind === 'loaded' &&
            page.hasWaitingTimesState.value
              ? `/wachttijden?centrum=${page.subCentra.centrum.title}`
              : undefined
        }
          title={page.title}
          intro={page.intro}
          image={page.image}
          link={page.link}
          contactItems={page.subCentra?.contactItems}
          appointmentUrl={page.subCentra?.appointmentUrl}
          centrum={
            page.subCentra?.centrum
              ? {
                  title: page.subCentra?.centrum.title,
                  url: `/afdelingen-en-centra/${page.subCentra?.centrum ? slugify(page.subCentra?.centrum.title) : ''}`,
                }
              : page.subCentra?.centrum
              ? {
                  title: page.subCentra.centrum?.title,
                  url: `/afdelingen-en-centra/${
                    page.subCentra.centrum.title ? slugify(page.subCentra.centrum.title) : ''
                  }`,
                }
              : undefined
          }
          breadcrumbs={subcentraBreadcrumbs(page)}
          menuItems={
            page.childrenState.kind === 'loaded'
              ? page.childrenState.value.map((child) => ({ ...child, active: child.url == page.url }))
              : undefined
          }
          menuOpened={page.menuOpened}
        />
      )),
      blocksWidget(acceptVideoCookie, {
        subcentrum: page.subCentra ? { title: page.subCentra.title, id: page.subCentra.id } : undefined,
      })(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
